// Simple clean icon marks for the fictional businesses we showcase across BackPocket.
// Uses lucide-react icons so every business has a recognisable, on-brand glyph
// (never a generic monogram).
import { Scissors, Coffee, Flower2, Dumbbell, Sparkles, Store } from "lucide-react";

const MARKS = {
  "Sharp & Sons": Scissors,
  "Ora Coffee": Coffee,
  "Pocket Coffee Co.": Coffee,
  "Pocket Coffee": Coffee,
  "Bloom Studio": Flower2,
  "Ironpark": Dumbbell,
  "Nomad Suds": Sparkles,
};

export function iconForBusiness(name) {
  return MARKS[name] || Store;
}

// Render a small badge for a business — icon inside a rounded tile.
// bg / fg let callers match the surrounding pass palette.
export function BusinessMark({ name, size = 40, radius, bg = "#0B0D10", fg = "#C8FF4D", strokeWidth = 2, className = "" }) {
  const Icon = iconForBusiness(name);
  const r = radius ?? Math.round(size * 0.26);
  return (
    <div className={`grid place-items-center shrink-0 ${className}`} style={{ width: size, height: size, background: bg, color: fg, borderRadius: r }}>
      <Icon size={Math.round(size * 0.5)} strokeWidth={strokeWidth} />
    </div>
  );
}
